function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { useSendEvent } from '@domain-group/fe-co-allhomes-analytics';
import { RecentItemCard } from '../option-card/presets';
import { jsx as ___EmotionJSX } from "@emotion/core";
var RecentItems = _ref => {
  var recentItems = _ref.recentItems,
    getItemProps = _ref.getItemProps,
    highlightedIndex = _ref.highlightedIndex,
    indexOffset = _ref.indexOffset;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  return ___EmotionJSX("ul", null, recentItems.map((item, index) => ___EmotionJSX("li", _extends({
    key: item.label
  }, getItemProps({
    item,
    index: index + indexOffset
  })), ___EmotionJSX(RecentItemCard, {
    selected: index + indexOffset === highlightedIndex,
    item: item,
    onClick: () => sendEvent('recent-item-click', {
      item: _objectSpread(_objectSpread({}, item), {}, {
        position: index
      })
    })
  }))));
};
RecentItems.propTypes = {
  recentItems: PropTypes.arrayOf(PropTypes.shape({})),
  highlightedIndex: PropTypes.number,
  indexOffset: PropTypes.number,
  getItemProps: PropTypes.func
};
RecentItems.defaultProps = {
  recentItems: [],
  highlightedIndex: -1,
  indexOffset: 0,
  getItemProps: () => {}
};
export default RecentItems;